module.exports = __webpack_public_path__ + "images/emoji/question.95a982486de152fde377.png";